import { revalidate,DEFAULT_LOCATION } from "@/globalConstants";

// Header is specifcally for some apis which helps backend to differenciate between app and web to send tailored responses 
const headers = new Headers({
    'Source': 'web'
});

// common method to make GET API calls with revalidation
const fetchJSON = async (url: string) => {
    try {
        const response = await fetch(url, { cache: 'force-cache', headers, next: revalidate });
        return await response.json();
    } catch (error) {
        console.error(error);
        return null;
    }
};

// common method to make GET API calls with custom headers headers  and no revalidation
const fetchWithConfig = async (url: string) => {
    try {
        const response = await fetch(url, { headers, cache: 'force-cache' });
        return await response.json();
    } catch (error) {
        console.error(error);
        return null;
    }
};

const fetchPrarthanas = async (url: string) => {
    try {
        const response = await fetch(url, { method: 'GET' });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching prarthanas:', error);
        throw error;
    }

}

// This API fetches users IPV4 IP 
export const getUserIPV4 = async () => {
    const response = await (await fetch('https://api.ipify.org?format=json', {
        cache: 'force-cache',
        next: revalidate,
    })).json();
    return response ? response.ip : null;
};
// this method fetchs users Location 
export const getUserLocation = async (): Promise<{ lat: number; long: number; city: string }> => {
    try {
        return {lat: DEFAULT_LOCATION.lat, long: DEFAULT_LOCATION.long, city: DEFAULT_LOCATION.city};
    } catch (error) {
        console.error('Error fetching user location:', error);
        throw error;
    }
};
export const getAllFestivals = async (timeStamp: number, location: { lat: number, long: number, city: string }) => {
    const { lat, long } = location;
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/v1/observances?limit=30&timestamp=${parseInt((timeStamp / 1000).toString())}&lat=${lat}&long=${long}`;
    return (await fetchWithConfig(url)).data.observances;
};
export const getAFestival = async (timeStamp: number, location: { lat: number, long: number, city: string }) => {
    const { lat, long } = location;
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/v1/observances?limit=1&timestamp=${timeStamp}&lat=${lat}&long=${long}`;
    return (await (await fetch(url)).json()).data.observances;
};
export const getAFestivalBySlug = async (festivalSlug: string) => {
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/v1/observances/slug/${festivalSlug}`;
    return (await (await fetch(url)).json());
};
export const getAllDeities = async () => {
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/prarthana/v1/deities`;
    return (await (await fetch(url, { cache: 'no-cache' })).json()).data;
};
export const getDeityByID = async (deityId: string) => {
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/prarthana/v1/deities/${deityId}`;
    return (await (await fetch(url, { cache: 'force-cache' })).json()).data;
};
export const getDeityDataByName = async (deityName: string) => {
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/prarthana/v1/deities/slug/${deityName}`;
    return (await (await fetch(url, { cache: 'no-store' })).json()).data;
};
export const getRashiPredition = async (date: string, rashiName: string, language: string) => {
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/prediction/v4/weekly?dates=${date}&rashi=${rashiName}&language=${language}`;
    const data = (await (await fetch(url, { cache: 'no-store' })).json()).data
    return data;
};
export const getPrarthanaById = async (prarthanaId: string) => {
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/prarthana/v1/prarthanas/${prarthanaId}`;
    return (await (await fetch(url, { cache: 'force-cache' })).json()).data;
};
export const getAllArticles = async () => (await (await fetch(`https://strapi-api.stage.dharmayana.in:1337/api/articles?sort[0]=id`)).json()).data;
export const getArticle = async (articleName: string) => (await (await fetch(`https://strapi-api.stage.dharmayana.in:1337/api/articles?filters[heading][$contains]=${articleName}`)).json()).data[0];
export const getArticleById = async (uid: string) => (await (await fetch(`https://strapi-api.stage.dharmayana.in:1337/api/articles/${uid}`)).json()).data;
export const getAllShubhKaryas = async () => (await fetchWithConfig(`${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/v1/app-config`)).data.shubh_karya_filters;
export const getAllLanguages = async () => (await fetchWithConfig(`${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/v1/app-config`)).data.prediction_languages;
export const getDatesForShubhKarya = async (timeStamp: number, karya: string, location: { lat: number, long: number, city: string }) => {
    const { lat, long } = location
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/v1/calendar?shubh_karya=${karya}&limit=30&timestamp=${parseInt((timeStamp / 1000).toString())}&lat=${lat}&long=${long}`;
    return (await fetchWithConfig(url)).data.calendar_view;
};
export const getPanchangaForToday = (timeStamp: number, location: { lat: number, long: number, city: string }) => {
    const { lat, long } = location;
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/v1/panchanga/details?timestamp=${parseInt((timeStamp / 1000).toString())}&lat=${lat}&long=${long}`;
    return fetchWithConfig(url);
};
export const getPrarthanasForToday = (timeStamp: number) => {
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/v1/panchanga/prarthanas/today?timestamp=${parseInt((timeStamp / 1000).toString())}`;
    return fetchWithConfig(url);
};
export async function getPurposePrarthanas() {
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/prarthana/v1/prarthanas/collection/purpose`;
    return fetchPrarthanas(url);

}
export const getPrarthanasByPurpose = async (purposeSlug: string) => {
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/prarthana/v1/prarthanas/slug/${purposeSlug}`;
    return fetchPrarthanas(url);
};
export async function getFestivalPrarthanas(pageNumber: number) {
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/v1/observances/linked-prarthanas?page_no=${pageNumber}&page_size=${12}`;
    return fetchPrarthanas(url);
}
export async function getPrarthanasByFestival(purposeSlug: string) {
    const url = `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/v1/observances/linked-prarthanas/${purposeSlug}`;
    return fetchPrarthanas(url);

}
export const suggestLocation = async (searchText: string, signal?: AbortSignal) => {
    const response = await fetch(
        `${process.env.NEXT_PUBLIC_BACKEND_BASE_URL}/v1/location/search?keyword=${searchText}`,
        { signal } // Pass the abort signal to the fetch call
    );
    const data = await response.json();
    return data.data;
};